import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchManyInputModule } from '../../base/fc-search-many-input/fc-search-many-input.module';
import { FcLocationsInputComponent } from './fc-locations-input.component';


@NgModule({
  declarations: [
    FcLocationsInputComponent
  ],
  imports: [
    FcSearchManyInputModule,
    TranslateModule
  ],
  exports: [
    FcLocationsInputComponent
  ]
})
export class FcLocationsInputModule {}
